$.onmount('[data-component=ecms-delivery-duty]', function () {
  var $el = $(this)

  function updateEcmsDeliveryDuty() {
    var $selectedOption = $el.find('option:selected')
    var shippingMethodName = $selectedOption.text()
    var $associatedField = $el.closest('.form-row').find('.ecms-delivery-duty')

    if (shippingMethodName === 'ECMS') {
      $associatedField.removeClass('d-none')
      $associatedField.prop('disabled', false)
    } else {
      $associatedField.addClass('d-none')
      $associatedField.prop('disabled', true)
    }
  }

  function updateAreaSelect() {
    var $areaSelect = $el.closest('.form-row').find('.area-select')
    if ($areaSelect.length === 0) return

    var selectedId = $el.val()
    var currentValue = $areaSelect.val()
    var map = {}

    try {
      map = JSON.parse($el.closest('form').attr('data-area-codes-map') || '{}')
    } catch (e) {
      return
    }

    var codes = (map[selectedId] || []).slice()

    if (currentValue && codes.indexOf(currentValue) === -1) {
      codes.push(currentValue)
    }

    codes.sort()

    var options = '<option value=""></option>'
    codes.forEach(function (code) {
      var selected = code === currentValue ? ' selected' : ''
      options += '<option value="' + code + '"' + selected + '>' + code + '</option>'
    })

    $areaSelect.html(options)
  }

  $el.on('change', function () {
    updateEcmsDeliveryDuty()
    updateAreaSelect()
  })
})
